import Operation from "../index.js";

export default {
    //获取用户信息
    getCurrentUser(fn) {
        Operation.Http.get(`/user/getCurrentUser`, null, fn)
    },
    getToken: () => {
        if(Operation.LocalStorage.get('token')) {
            if(!Operation.SessionStorage.get('token')) {
                Operation.SessionStorage.set('token', Operation.LocalStorage.get('token'))
            }
            return Operation.LocalStorage.get('token')
        } else if(Operation.SessionStorage.get('token')) {
            return Operation.SessionStorage.get('token')
        }
        return null;
    },
    setToken: (token) => {
        Operation.LocalStorage.set('token', token)
        return Operation.SessionStorage.set('token', token)
    },
    deleteToken: () => {
        Operation.LocalStorage.delete('token')
        return Operation.SessionStorage.delete('token')
    }
    // getLocalToken: function() {
    //     return Operation.LocalStorage.get('token')
    // },
    // setLocalToken: function(token) {
    //     return Operation.LocalStorage.set('token', token)
    // },
}


// WEBPACK FOOTER //
// ./src/request/api/user.js